"use strict";

/**
* Колонка таблицы.
* 
* @class WebAccess.components.wrappers.form.TableColumn
* @extends BaseObject
* @property {string} reqName Имя реквизита.
* @property {WebAccess.components.wrappers.form.Table} parentTable Таблица, которой принадлежит колонка.
* @param {number} num Номер детального раздела.
*/
(function (global) {

  var TableColumn = BaseObject.extend({
    className: "TableColumn",

    reqName: '',
    _parentTable: null,
    _isDisabled: null,
    _isRendered: null,
    _isVisible: null,
    _isSystem: null,
    _isCanGUIRead: null,
    number: null,
    dfmName: '',

    init: function (reqName, parentTable, num) {
      var me = this;
      me._super();
      me.name = reqName;
      me.reqName = reqName;
      me._parentTable = parentTable;
      me.number = num;

      // Получить метаинформацию по колонке
      var currentColumnMetadata = me._parentTable.getColumnMetadata(me.reqName);

      me.dfmName = currentColumnMetadata.DFMName;

      // Установить свойства изменяемости и доступности
      me._isDisabled = currentColumnMetadata.IsReadOnly;
      me._isVisible = currentColumnMetadata.IsVisible;
      me._isSystem = currentColumnMetadata.IsSystem;
      me._isRendered = currentColumnMetadata.IsRendered;
      me._isCanGUIRead = currentColumnMetadata.IsCanGUIRead;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить свойство возможности визуального чтения реквизита.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#getCanGUIRead
    * @return {boolean} True – значение отображается, иначе False.
    */
    getCanGUIRead: function() {
      return this._isCanGUIRead;
    },

    /**
    * Установить свойство возможности визуального чтения реквизита.
    * Данное свойство не изменяет визуально колонку, т.к. при установке значения в True необходимо
    * получать и устанавливать значения каждой строки детального раздела.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#setCanGUIRead
    */
    setCanGUIRead: function(value) {
      this._isCanGUIRead = value;
    },

    /**
    * Признак недоступности колонки для изменения.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#isDisabled
    * @return {boolean} True – колонка доступна только для чтения , иначе False.
    */
    isDisabled: function () {
      return this._isDisabled;
    },

    /**
    * Признак видимости колонки.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#isVisible
    * @return {boolean} True – колонка отображается, иначе False.
    */
    isVisible: function () {
      return this._isVisible;
    },

    /**
    * Признак, что реквизит колонки системный.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#isSystem
    * @return {boolean} True – реквизит колонки системный, иначе False.
    */
    isSystem: function () {
      return this._isSystem;
    },

    /**
    * Признак наличия колонки в списке отображаемых.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#isRendered
    * @return {boolean} True – колонка была вынесена на форму в редакторе форм, иначе False.
    */
    isRendered: function () {
      return this._isRendered;
    },

    /**
    * Cделать колонку недоступной для изменения.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#disable
    * @return {WebAccess.components.wrappers.form.TableColumn} Объект типа TableColumn.
    */
    disable: function () {
      var me = this;
      var rows = me._parentTable.rows.toArray();
      rows.forEach(function (currentRow) {
        currentRow.requisites[me.reqName].disable();
      });
      me._isDisabled = true;
      return me;
    },

    /**
    * Cделать колонку доступной для изменения.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#enable
    * @return {WebAccess.components.wrappers.form.TableColumn} Объект типа TableColumn.
    */
    enable: function () {
      var me = this;
      var rows = me._parentTable.rows.toArray();
      rows.forEach(function (currentRow) {
        currentRow.requisites[me.reqName].enable();
      });
      me._isDisabled = false;
      return me;
    },

    /**
    * Скрыть колонку.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#hide
    * @return {WebAccess.components.wrappers.form.TableColumn} Объект типа TableColumn.
    */
    hide: function () {
      if (this._isRendered) {
        this._parentTable._grid.hideColumn(this.reqName);
        this._isVisible = false;
      }
      return this;
    },

    /**
    * Показать колонку.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#show
    * @return {WebAccess.components.wrappers.form.TableColumn} Объект типа TableColumn.
    */
    show: function () {
      var me = this;
      if (me._isRendered) {
        var index = 0;
        var parentGrid = me._parentTable._grid;
        parentGrid._columns.some(function (currentColumn) {
          if (currentColumn.id === me.reqName) {
            index = currentColumn.index;
            return true;
          }
          return false;
        });
        parentGrid.showColumn(me.reqName, index);
        me._isVisible = true;
      }
      return me;
    },

    /**
    * Возвращает таблицу, к которой относится колонка.
    *
    * @method WebAccess.components.wrappers.form.TableColumn#getTable
    * @return {WebAccess.components.wrappers.form.Table} Объект типа Table
    */
    getTable: function () {
      return this._parentTable;
    }
  });

  global.components.wrappers.form.TableColumn = TableColumn;
})(window.WebAccess);